var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationsSharp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 17.5,
    viewBox: "0 0 15 17.5",
    width: 15,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3c2f87",
    transform: "translate(-4.499 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.709 32.25a3.128 3.128 0 0 0 2.863-1.875h-5.726a3.128 3.128 0 0 0 2.863 1.875z",
    transform: "translate(-3.71 -12.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.625 12.25v-2.364c0-2.753-1.069-5.151-3.75-5.761l-.313-1.875h-3.125l-.313 1.875c-2.691.61-3.75 3-3.75 5.761v2.364l-1.874 2.5v1.875h15v-1.875z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsSharp);
export default __webpack_public_path__ + "static/media/notifications-sharp.72c023e82d6b63b7e0787841bebb31a0.svg";
export { ForwardRef as ReactComponent };